import { render, staticRenderFns } from "./MainJou.vue?vue&type=template&id=3ddcea70&scoped=true&"
import script from "./MainJou.vue?vue&type=script&lang=js&"
export * from "./MainJou.vue?vue&type=script&lang=js&"
import style0 from "./MainJou.vue?vue&type=style&index=0&id=3ddcea70&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ddcea70",
  null
  
)

export default component.exports